import { Type } from 'class-transformer';

export default class ProcessModel {
  id!: number;

  idProcesso!: number;

  atendente!: string;

  @Type(() => Date)
  data!: Date;

  dataString!: string;

  etapa!: string;

  idFila!: number;

  fila!: string;

  fluxo!: string;

  idFluxo!: number;

  tipoFluxo!: number;

  cliente!: string;

  cnpj!: string;

  tipoCliente!: string;

  descricao!: string;

  dataLimiteEtapa!: string;

  permiteDetalharQualquerEtapa!: boolean;

  temFluxoEtapaUsuario!: boolean;

  temFluxoEtapaUsuarioEtapaAtual!: boolean;

  etapaFinal!: boolean;

  resultado!: string;

  resultadoPositivo!: boolean;

  motivo?: string;
}
